module.exports = __webpack_public_path__ + "static/bg.0e30cb95.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/screener/bg.svg
// module id = 3738
// module chunks = 58308676151394